module.exports = __webpack_public_path__ + "img/banner-loja-cover.68b616fb.jpeg";